// Badge colours per task_status_id
export const taskStatusClass = {
  2: 'bg-slate-100 text-slate-700',
  3: 'bg-blue-100 text-blue-700',
  4: 'bg-indigo-100 text-indigo-700',
  5: 'bg-amber-100 text-amber-700',
  6: 'bg-teal-100 text-teal-700',
  7: 'bg-green-100 text-green-700',
  8: 'bg-orange-100 text-orange-700',
  9: 'bg-red-100 text-red-700',
};

// total_sales_order_amount arrives preformatted, e.g. "₦21,340.00"
export const amountToNumber = value => Number(String(value ?? '').replace(/[^\d.-]/g, '')) || 0;
